import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ApiSeo } from 'idt-ecommerce-api/_api/api-web/api-seo/api-seo.models';
import { ApiSeoService } from 'idt-ecommerce-api/_api/api-web/api-seo/api-seo.service';

import { Seo } from './seo.models';
import { SeoModelsTransformer } from './seo.models.transformer';


@Injectable()
export class SeoService {

  constructor(
    private readonly apiSeoService: ApiSeoService
  ) { }

  /**
   * Obtiene la información de Seo de una cadena
   */
  public seo() {
    return this.apiSeoService.seo().pipe(
      map((apiSeo: ApiSeo) => {
        const seo: Seo = SeoModelsTransformer.seoFromApi(apiSeo);
        return seo;
      })
    );
  }

}
